export default __webpack_public_path__ + "static/media/background.ceabf172.png";